<template>
  <!-- eslint-disable -->
  <div class="background-padding d-flex flex-column align-items-center p-2">
    <table>
      <tbody>
        <tr>
          <td>
            <p style="color:rgb(85,91,95)">
              U Lifestyle 作為最緊貼用戶生活的資訊性網絡平台，一直提供吃‧喝‧玩‧樂‧遊的資訊。此外，現設有《U Lifestyle商戶中心》，讓品牌透過U Lifestyle旗下網站及手機App，放送各種獨家優惠供會員換領及選購！<br />
            </p>
            <p>
              <p>&nbsp;</p>
            </p>
            <p style="font-size: 18pt;">
              <b>成為U Lifestyle 優惠商戶</b>
            </p>
            <div>
              <img src="../../../assets/img/merchant-page-graphic1@4x.png" />
            </div>
            <p style="color:rgb(85,91,95)">
              <br />
              無論是實體店或網店，都可以申請成為 U Lifestyle 優惠商戶，將獨家積分優惠及預付優惠帶給龐大活躍用戶群、增加品牌曝光、接觸更多潛在客戶，會員更有機會即買即賺U Fun換領各種禮遇！
              <p>&nbsp;</p>
            </p>
            <p style="font-size: 18pt;">
              <b>功能特色</b>
            </p>
            <div>
              <img src="../../../assets/img/merchant-page-graphic2@4x.png" />
            </div>
            <p>&nbsp;</p>

            <p style="margin-bottom: 4px">
              <b>O2O促銷</b>
              <p style="color:rgb(85,91,95)">
                隨時上載及管理優惠，多種優惠格式選擇如文字優惠碼及二維碼等令商戶及會員更容易使用，帶來更多線上線下的銷售機會，提高流量。
              </p>
            </p>

            <p style="margin-bottom: 4px">
              <b>積分優惠</b>
              <p style="color:rgb(85,91,95)">
                提供限時優惠碼予會員以U Fun換領折扣優惠，提高促銷活動成效。
              </p>
            </p>

            <p style="margin-bottom: 4px">
              <b>付費優惠</b>
              <p style="color:rgb(85,91,95)">
                利用預先購買優惠，鼓勵潛在顧客先買後享同時賺取U⁠ ⁠Fun，加快現金流動。
              </p>
            </p>

            <p style="margin-bottom: 4px">
              <b style="color:rgb(51,51,51)">全面數據</b>
              <p style="color:rgb(85,91,95)">
                平台展示圖像化數據報表，一覽過往優惠換領次數、訂單銷售額等數據。
              </p>
            </p>

            <p style="margin-bottom: 4px">
              <b style="color:rgb(51,51,51)">數位營銷</b>
              <p style="color:rgb(85,91,95)">
                進行促銷活動刺激受眾衝動消費，吸納更多潛在客戶。會員可於U Lifestyle App《U Jetso》優惠專區瀏覽各項最新及熱門優惠，點擊優惠後，更可查看相關品牌資訊、優惠及過去品牌相關文章，全方位認識您的品牌，配合U Lifestyle 全方位宣傳，讓營銷宣傳更全面。
              </p>
              <p style="color:rgb(85,91,95)">
                超過數百個品牌已經成為我們的優惠商戶，類型包括：零售、服務、餐飲、酒店住宿、活動體驗工作坊、電子、美妝時尚、生活、旅遊等應有盡有！
              </p>
              <p style="color:rgb(85,91,95)">
                如有興趣成為U Lifestyle商戶中心的優惠商戶，立即點擊「成為優惠商戶」，以電郵接收邀請連結，加入成為優惠商戶！
              </p>
            </p>

            <div class="button-wrapper">
              <b-button v-if="invitationEmail !== ''"
              @click="handleSendEmail()"
              class="detail-button">
                成為優惠商戶
              </b-button>
              <b-button v-if="invitationEmail === ''"
                @click="openInputEmailModal()" class="detail-button">
                成為優惠商戶
              </b-button>

            </div>

            <EmailModal @sendbtn="handleInputEmail"></EmailModal>
            <SentSuccessModal @close-modal="cleanInputEmail":invitationEmail="invitationEmail"></SentSuccessModal>
            <LoadingSpinner v-show="loading"></LoadingSpinner>
          </td>
        </tr>

      </tbody>
    </table>
    <p style="font-weight: 400;">&nbsp;</p>
  </div>
</template>

<script>
import EmailModal from '@/components/merchant/EmailModal.vue';
import SentSuccessModal from '@/components/merchant/SentSuccessModal.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import http from '@/helpers/http';
import {
  switchMap, tap, filter,
} from 'rxjs/operators';
import { BButton } from 'bootstrap-vue';
import { getErrorMsg } from '@/helpers/error-msg';
import toastSettings from '@/helpers/toast-settings';

export default {
  components: {
    BButton,
    EmailModal,
    SentSuccessModal,
    LoadingSpinner,
  },
  data: () => ({
    loading: false,
    invitationEmail: '',
  }),
  domStreams: ['onClick$'],
  subscriptions() {
    return {
      onClick: this.onClick$.pipe(
        filter((email) => email.data !== ''),
        tap(() => {
          this.loading = true;
        }),
        switchMap(() => http({
          method: 'POST',
          url: '/agc-public-api/membership/sendBrandCreatorInvitation',
          data: {
            receiver: this.invitationEmail,
          },
        }, {
          error: ({ data: { msg } }) => {
            this.$bvToast.toast(getErrorMsg(msg), {
              ...toastSettings,
              title: '錯誤',
              toaster: 'b-toaster-top-center',
            });
          },
          next: (res) => {
            if (res) {
              this.invitationEmail = '';
            }
          },
          complete: () => {
            this.loading = false;
            this.$bvModal.show('modal-brand-creator-sent');

            window.dataLayer.push({
              event: 'ultriggerpageview',
              ga4: {
                channel: 'www',
                service: 'merchant',
                pageurl: window.location.href,
                screen: 'mc_apply',
                pagename: window.document.title,
                text: 'email_sent',
              },
              _clear: true,
            });
          },
        })),
      ),
    };
  },

  methods: {
    setinvitationEmail() {
      this.invitationEmail = this.$route.query.invitationEmail ? this.$route.query.invitationEmail : '';
    },
    cleanInputEmail(val) {
      if (val === true) {
        this.invitationEmail = '';
      }
    },
    handleSendEmail() {
      this.$observables.onClick.next({ data: this.invitationEmail });

      window.dataLayer.push({
        event: 'btnEventTrigger',
        ga4: {
          channel: 'www',
          event_name: 'button_tap',
          service: 'merchant',
          pageurl: window.location.href,
          screen: 'mc_apply',
          text: '商戶加盟',
        },
        _clear: true,
      });
    },
    handleInputEmail(val) {
      this.invitationEmail = val;
      // this.closeInputEmailModal();

      // manually emit an Observable API
      this.$observables.onClick.next({ data: val });

      window.dataLayer.push({
        event: 'btnEventTrigger',
        ga4: {
          channel: 'www',
          event_name: 'button_tap',
          service: 'merchant',
          pageurl: window.location.href,
          screen: 'mc_apply',
          text: '發送電郵邀請',
        },
        _clear: true,
      });
    },
    openInputEmailModal() {
      this.$bvModal.show('modal-brand-creator');

      window.dataLayer.push({
        event: 'btnEventTrigger',
        ga4: {
          channel: 'www',
          event_name: 'button_tap',
          service: 'merchant',
          pageurl: window.location.href,
          screen: 'mc_apply',
          text: '商戶加盟',
        },
        _clear: true,
      });
    },
    closeInputEmailModal() {
      this.$bvModal.hide('modal-brand-creator');
    },
  },

  watch: {
    invitationEmail() {
      if (this.invitationEmail === '' && this.$route.query.invitationEmail) {
        this.setinvitationEmail();
      }
    },
  },

  mounted() {
    this.setinvitationEmail();
  },

};
</script>

<style scoped lang="scss">
table {
  max-width: 50rem;
}

img {
  width: 100%;
}

b {
  font-weight: 500;
}

.background-padding {
  @include respond(tab-landscape) {
    padding-left: 16pt !important;
    padding-right: 16pt !important;
  }
}

.button-wrapper {
  text-align:center;
  @include respond(tab-landscape) {
    width: 100%;
    padding-top: 10px;
    position: sticky;
    bottom: 5%;
  }
  .detail-button {
    @include respond(tab-landscape) {
      width: 65%;
    }
    display: inline-block;
    color: #FFF;
    border: none;
    // border: 2px solid rgb(48,135,217);
    font-size: 16px;
    border-radius: 25px;
    background: none;
    background-color: rgb(48,135,217);
    box-sizing: border-box;
    padding: 0px 15px;
    height: 40px;
    width: 212px;
  }
}

</style>
